import { getResumeFileType } from "./resumeFileType";
import { parseResumeClientSide } from "./resumeParserClient";
import { sanitizeResumeText } from "../../../../server/sanitizeResumeText";

/**
 * Matches seekers-webapp parseResume() in PositionDetailRight.jsx.
 * Uses /api/parse-pdf on the same origin when available (dev server or Node production server).
 * Falls back to client-side parsing on static hosting (e.g. nginx serving build/ only).
 */
export const parseResumeFromUrl = async (resumeUrl) => {
  if (!resumeUrl?.trim()) {
    throw new Error("Missing resume URL");
  }

  if (typeof window === "undefined" || !window.location?.origin) {
    throw new Error("window.location.origin is required to parse resume");
  }

  const fileType = getResumeFileType(resumeUrl);
  const apiEndpoint = fileType === "pdf" ? "/api/parse-pdf" : "/api/parse-doc";
  const parseUrl = new URL(apiEndpoint, window.location.origin);
  parseUrl.searchParams.set("url", resumeUrl);

  try {
    const response = await fetch(parseUrl.toString());
    const contentType = response.headers.get("content-type") || "";

    if (!contentType.includes("text/html")) {
      const data = await response.json();

      if (response.ok && data?.text) {
        return sanitizeResumeText(data.text);
      }

      if (!response.ok) {
        throw new Error(data?.error || "Failed to parse resume");
      }
    }
  } catch (error) {
    if (
      error instanceof Error &&
      !error.message.includes("JSON") &&
      !error.message.includes("Unexpected token")
    ) {
      throw error;
    }
  }

  return parseResumeClientSide(resumeUrl);
};
